<template>
  <div class="senior-file-viewer-wrapper">
    <file-viewer
      :title="title"
      :subtitle="seniorInfo.activity_name"
      :pkg="{ type: 'case', id: seniorInfo.id }"
      :all-downloadable="true"
      :original-file-list="seniorInfo.files || []"
      :original-article-list="seniorInfo.articles || []"
    >
      <div slot="listHeader" class="view-list-header">
        <div v-if="seniorInfo.brand" class="brand-wrapper">
          <div class="brand-logo">
            <img :src="seniorInfo.thumbnail" />
          </div>
          <div class="brand-text">
            <h3 class="brand-name">{{ seniorInfo.brand.name }}</h3>
            <div class="put-time">
              {{
                seniorInfo.start_time
                  | relativeTimeFormat('M月', { isRough: true })
              }}
              投放
            </div>
          </div>
        </div>
        <h1 class="title">{{ seniorInfo.activity_name }}</h1>
      </div>
      <div slot="listFooter" class="view-list-footer"></div>
    </file-viewer>
  </div>
</template>

<script>
import FileViewer from '@/components/fileViewer/FileViewer'
import { ABS_PATH } from '@/global/config'

export default {
  components: {
    FileViewer
  },
  props: {
    seniorInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      qrcode: `${ABS_PATH.qrcode}?type=senior_case&size=10&case_id=${this.seniorInfo.id}`,
      praiseDisabled: false,
      favoriteDisabled: false
    }
  },
  computed: {
    title() {
      const length = (this.seniorInfo.files || []).length
      return length > 0 ? `案例资料 ${length} 个` : '案例资料'
    }
  }
}
</script>

<style lang="scss" scoped>
.view-list-header {
  padding: 24px 24px 0 24px;
  .brand-wrapper {
    overflow: hidden;
    margin-bottom: 17px;
    .brand-logo {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      overflow: hidden;
      float: left;
      margin-right: 12px;
      img {
        width: 100%;
        height: 100%;
        float: left;
        object-fit: cover;
      }
    }
    .brand-text {
      height: 48px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .brand-name {
      font-size: 14px;
      font-weight: bold;
    }
    .put-time {
      font-size: 13px;
      color: #727272;
    }
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
  }
}
.view-list-footer {
  height: 46px;
  line-height: 46px;
  border-top: 1px solid #efeff3;
  ul {
    li {
      float: left;
      width: 33.333333%;
      text-align: center;
    }
    .btn-item {
      font-size: 14px;
      color: #363636;
      cursor: pointer;
      background-color: transparent;
      border: none;
      outline: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      i {
        font-size: 20px;
        margin-right: 4px;
      }
    }
  }
  .btn-item {
    width: 100%;
    &:hover {
      color: #3352fe;
    }
    &.on {
      color: #f8653f;
    }
  }
}
.share-channels {
  .channel {
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    display: inline-block;
    background-color: #efeff3;
    border-radius: 50%;
    color: #8e9091;
    cursor: pointer;
    border: 1px solid #efeff3;
    margin-right: 12px;
    position: relative;
    &:hover {
      background-color: #ffffff;
      color: #363636;
    }
  }
  .wechat {
    .qrcode {
      position: absolute;
      width: 84px;
      height: 84px;
      overflow: hidden;
      box-sizing: border-box;
      border: 1px solid #efeff3;
      bottom: 100%;
      left: -22px;
      margin-bottom: 4px;
      padding: 2px;
      background-color: #ffffff;
      display: none;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &:hover {
      .qrcode {
        display: block;
      }
    }
  }
  i {
    font-size: 22px;
  }
}
</style>

<style lang="scss">
.senior-file-share-popper {
  box-shadow: none;
  border: none;
  padding: 3px 3px 7px;
  background-color: transparent;
}
</style>
